import { api } from "@/config/api-fetch";
import { useQuery } from "@tanstack/react-query";

export type RecentQuery = {
    query: string;
    is_helpful: boolean | null;
    created_at: string;
};

export type SearchAnalytics = {
    block_count: number;
    total_queries: number;
    monthly_queries: number;
    helpful_votes: number;
    unhelpful_votes: number;
    recent_queries: RecentQuery[];
};

export function useSearchAnalytics() {
    return useQuery<SearchAnalytics>({
        queryKey: ["search-analytics"],
        queryFn: async () => api.get<SearchAnalytics>("/search-analytics"),
    });
}
